/**
 * SelectAllTableOption — renders the "Select All (N)" checkbox that
 * sits above the DataGrid in the Bulk Add Course Section modal.
 *
 * This is a presentational-only component.  It renders a checkbox
 * whose `checked` state and `onChange` handler are fully controlled
 * by the parent (Table.tsx).
 *
 * `totalCount` comes from the CDG pagination metadata
 * (`pagination.totalResults`) so the label reflects the total across
 * all pages, not just the visible page.  This is intentional — the
 * user should know how many sections they are about to bulk-add.
 *
 * When checked, the parent enters "Select All mode", which tells the
 * backend to apply the operation to every section matching the current
 * filters (minus any explicit exclusions tracked in `unselectedIds`).
 */
import React from 'react'
import { Typography, Box } from '@mui/material'
import FormCheckbox from '../../../../components/FormElements/FormCheckBox'

interface TableHeaderProps {
  allSelected: boolean
  onSelectAll: (e: React.ChangeEvent<HTMLInputElement>) => void
  /** Total matching rows across all pages (from CDG pagination). */
  totalCount: number
}

const SelectAllTableOption: React.FC<TableHeaderProps> = ({ allSelected, onSelectAll, totalCount }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', mt: 4 }}>
    <FormCheckbox
      name="selectAll"
      checked={allSelected}
      onChange={onSelectAll}
    />
    <Typography sx={{ fontWeight: 600, fontSize: 16 }}>
      Select All <Box component="span" sx={{ fontWeight: 600, display: 'inline' }}>({totalCount})</Box>
    </Typography>
  </Box>
)

export default SelectAllTableOption
